import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { WEBSOCKET_URL } from '../config';

export const useWebSocket = () => {
  const [notification, setNotification] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [authError, setAuthError] = useState(null);

  useEffect(() => {
    const authToken = localStorage.getItem('userAuthToken');

    if (!authToken) {
      console.warn('[WebSocket] No auth token found, skipping connection');
      setAuthError('No authentication token');
      return;
    }

    const socket = io(WEBSOCKET_URL, {
      transports: ['websocket', 'polling'],
      auth: {
        token: authToken
      }
    });

    socket.on('connect', () => {
      console.log('[WebSocket] Connected and authenticated');
      setIsConnected(true);
      setAuthError(null);
    });

    socket.on('connect_error', (error) => {
      console.error('[WebSocket] Connection error:', error.message);
      setAuthError(error.message);
      setIsConnected(false);
    });

    socket.on('disconnect', () => {
      console.log('[WebSocket] Disconnected');
      setIsConnected(false);
    });

    socket.on('app-update', (data) => {
      console.log('[WebSocket] App update notification received:', data);
      setNotification(data);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const clearNotification = () => {
    setNotification(null);
  };

  return {
    notification,
    isConnected,
    authError,
    clearNotification
  };
};
